export default class TabSwitchableOptionList {
  constructor(root) {
    this._elTabs = root.querySelector(':scope > .tabs');
    const elSubOptionLists = root.querySelector(':scope > .subOptionLists');
    this._arrElSubOptionList = elSubOptionLists.querySelectorAll(':scope > .subOptionList');
    
    const value = this._elTabs.querySelector('.tab:checked').value;
    this._elCurrentOption = elSubOptionLists.querySelector(`:scope > .subOptionList[data-name=${value}]`);
    
    this._elTabs.addEventListener('input', () => {
      const value = this._elTabs.querySelector('.tab:checked').value;
      this._arrElSubOptionList.forEach(v => {
        if(v.getAttribute('data-name') === value) {
          v.classList.remove('hidden');
          this._elCurrentOption = v;
        } else {
          v.classList.add('hidden');
        }
      });
    });
  }
}
